import { createContext } from 'react'

type TOnValidate = (name: string, error: string) => void

const ErrorContext = createContext<{ onValidate: TOnValidate; getError: (name: string) => string }>({
  onValidate: () => {},
  getError: () => '',
})
export default ErrorContext
